import {createFeatureSelector, createSelector} from '@ngrx/store';
import {Features} from '../features';
import {ParametryBiznesowe} from './parametryBiznesowe';

export const selectParametryBiznesowe = createFeatureSelector<ParametryBiznesowe<string | number>>(Features.PARAMETRY_BIZNESOWE)

export const selectParametrBiznesowyByName = createSelector(
  selectParametryBiznesowe,
  (entities: ParametryBiznesowe<string | number>, name: string) => entities[name]
);
